"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Slider.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Chervron = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.294983 10.5949L4.87498 6.00488L0.294982 1.41488L1.70498 0.00488275L7.70498 6.00488L1.70498 12.0049L0.294983 10.5949Z",
    fill: "currentColor"
  }));
};
const Slider = _ref => {
  let {
    children
  } = _ref;
  const slideRef = (0, _react.useRef)(null);
  const leftBtnRef = (0, _react.useRef)(null);
  const rightBtnRef = (0, _react.useRef)(null);
  const [scrollWidth, setScrollWidth] = (0, _react.useState)(0);
  const [clientWidth, setClientWidth] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    function handleResize() {
      setScrollWidth(slideRef.current?.scrollWidth);
      setClientWidth(slideRef.current?.clientWidth);
    }
    if (typeof window !== 'undefined') {
      handleResize();
      window.addEventListener('resize', handleResize);
      leftBtnRef.current.disabled = true;
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  const handleClickLeft = () => {
    slideRef.current.scrollLeft -= clientWidth;
  };
  const handleClickRight = () => {
    slideRef.current.scrollLeft += clientWidth;
  };
  const handleScroll = () => {
    leftBtnRef.current.disabled = slideRef.current.scrollLeft <= 0;
    rightBtnRef.current.disabled = slideRef.current.scrollLeft >= scrollWidth - clientWidth;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-slider`
  }, /*#__PURE__*/_react.default.createElement("button", {
    ref: leftBtnRef,
    type: "button",
    className: "ter-slider__btn ter-slider__btn--left",
    onClick: handleClickLeft
  }, /*#__PURE__*/_react.default.createElement(Chervron, null)), /*#__PURE__*/_react.default.createElement("div", {
    ref: slideRef,
    onScroll: handleScroll,
    className: "ter-slider__slide"
  }, children), /*#__PURE__*/_react.default.createElement("button", {
    ref: rightBtnRef,
    type: "button",
    className: "ter-slider__btn ter-slider__btn--right",
    onClick: handleClickRight
  }, /*#__PURE__*/_react.default.createElement(Chervron, null)));
};
var _default = Slider;
exports.default = _default;